import {
  Bot,
  ChartCandlestick,
  Grid3x3,
  LucideIcon,
  Radio,
  Split,
} from "lucide-react";
import { BotType } from "@shared/types";

/** The new look's line icon for each bot type (sidebar, pickers, cards). */
export const NEW_LOOK_BOT_TYPE_TO_ICON: Record<BotType, LucideIcon> = {
  [BotType.ASAP]: Bot,
  [BotType.TRADING_VIEW]: ChartCandlestick,
  [BotType.TRADING_VIEW_SIGNALS]: ChartCandlestick,
  [BotType.GRID]: Grid3x3,
  [BotType.SIGNAL]: Radio,
  [BotType.HEDGING]: Split,
};
